var map = {
	"./3do.svg": "6ac201f21d",
	"./android.svg": "4b801e35a4",
	"./atari.svg": "5410c4758d",
	"./black/3do.svg": "97a6a4e7bc",
	"./black/android.svg": "69b31cf6ae",
	"./black/atari.svg": "a21dbfd890",
	"./black/commodore-amiga.svg": "efb132556a",
	"./black/ios.svg": "15b5828e32",
	"./black/linux.svg": "46f1b6d4a3",
	"./black/mac.svg": "a76993bce0",
	"./black/nintendo.svg": "dce32eff72",
	"./black/pc.svg": "2a2515245a",
	"./black/playstation.svg": "d838184d23",
	"./black/sega.svg": "abfc1f0d10",
	"./black/web.svg": "279891ba76",
	"./black/xbox.svg": "dbb11f4814",
	"./commodore-amiga.svg": "7373f80dba",
	"./ios.svg": "c127ecaaf9",
	"./linux.svg": "230a0fa490",
	"./mac.svg": "2365ea18a4",
	"./nintendo.svg": "e51b1bbcdb",
	"./pc.svg": "1640173266",
	"./playstation.svg": "de6c94e578",
	"./sega.svg": "69ff26c4ee",
	"./web.svg": "23be8a70ba",
	"./xbox.svg": "84361dea29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3741b72c9";